var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "telegram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.132,
    y1: 0.161,
    x2: 0.926,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28aae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23b7ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1726092097792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1668",
    "data-name": "Caminho 1668",
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1669",
    "data-name": "Caminho 1669",
    d: "M169.063,157.323l-4.473,22.548a1.656,1.656,0,0,1-2.345.814l-10.32-7.913-.048-.023c1.394-1.252,12.2-10.971,12.676-11.411.731-.682.277-1.088-.572-.573L148.015,170.9l-6.16-2.073s-.969-.345-1.063-1.095,1.095-1.157,1.095-1.157L167,156.729S169.063,155.822,169.063,157.323Z",
    transform: "translate(-133.146 -144.673)",
    fill: "#fefefe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f0f5fb60a18a3b72d06472867e2ddc83.svg";
export { ForwardRef as ReactComponent };